const styles = (theme: Object) => ({
  formPanel: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.backgrounds.main,
    position: 'relative',
    top: 106,
    padding: '30px 0',
  },
  page: {
    margin: '0 auto 30px auto',
  },
});

export default styles;
